import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography, IconButton, Collapse } from '@mui/material';
import { AddCircleOutline as AddIcon, ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon, Close as CloseIcon } from '@mui/icons-material';
import { useWebSocket } from './WebSocketContext';
import '../styles/AddCase.css';
import { useLocation } from 'react-router-dom';

const GetCase = () => {
  const location = useLocation();
  const { ws, subscribeToMessages } = useWebSocket();
  const [folder, setFolder] = useState('');
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const directory = params.get('directory');
    console.log("directory: " + directory);
    setFolder(directory);

    if (directory) {

      const interval = setInterval(() => {
        if (ws && ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify({ command: 'isFolderExist', folder: directory }));
          clearInterval(interval); // Stop checking after sending the message
        } else if (!ws) {
          console.error("WebSocket is not initialized.");
        } else {
          console.log("Waiting for WebSocket to open...");
        }
      }, 100); // Check every 100ms

      // Cleanup interval on component unmount or on change
      return () => clearInterval(interval);
    } else {

    }
  }, [ws, location.search]);

  useEffect(() => {
    const unsubscribe = subscribeToMessages((parsedMessage) => {
      // Message is already parsed in WebSocketContext
      if (parsedMessage.command === 'isFolderExist') {
        // if data is bigger than -1 then folder exist
        console.log(parsedMessage.data);
        if (parsedMessage.data > -1) {
          window.location.href = "/case/" + parsedMessage.data;
        }
        else {
          window.location.href = "/add?directory=" + folder;
        }
      }
      });
    return unsubscribe; // Cleanup by unsubscribing
  }, [subscribeToMessages]);

  return (
    <div style={{ padding: '20px' }}>
      Please wait...
    </div>

  );
};

export default GetCase;
